import { useChannelName } from "./hooks/use_channel_name";

export function ChannelName(props: {
	channel_id: string;
	include_hashtag?: boolean;
}) {
	const channel_name = useChannelName(
		props.channel_id,
		props.include_hashtag
	);

	return <ChannelNameWithoutCache channel_name={channel_name} />;
}

export function ChannelNameWithoutCache(props: { channel_name: string }) {
	return (
		<span className="inline-flex min-w-0 max-w-full">
			<span className="overflow-hidden overflow-ellipsis">
				{props.channel_name}
			</span>
		</span>
	);
}
